import { useTranslation } from 'react-i18next'

import { useQuote } from '../../contexts/quoteContext'

export const QuoteTitle = () => {
  const { t } = useTranslation()
  const { quote } = useQuote()

  const quoteNumber = quote?.estimateNumber

  return t('quotes.view.title', { quoteNumber })
}
